// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-content {
  --background: white;
}

.qr-toolbar {
  text-align: right;
}

#downladableQr div {
  margin-left: 35px;
  margin-right: 35px;
}

#options-qr {
  justify-content: center;
}
#options-qr ion-col {
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  font-size: 14px;
  margin-bottom: 10px;
}
#options-qr ion-col ion-icon {
  padding-right: 8px;
}

#title-modal {
  font-weight: 700;
  font-size: 17px;
  color: var(--ion-text-color);
  margin: 0px 0px 16px 0px;
  padding-left: 16px;
  padding-right: 16px;
}

#subtitle-modal {
  font-weight: 400;
  font-size: 17px;
  color: var(--ion-text-color);
  margin: 0px 0px 16px 0px;
}

.break-line {
  white-space: pre-wrap;
}

#scan {
  font-weight: 500;
  font-size: 14px;
  color: var(--ion-text-color);
  margin: 7px 0px 7px 42px;
}

#goToSite {
  color: var(--ion-color-secondary);
}

.row-actions {
  padding: 0px 55px;
}

.btn-clear {
  --box-shadow: none;
}

.btn-no-margin {
  margin: 0px !important;
}`, "",{"version":3,"sources":["webpack://./src/modules/@boxx/panel-core/lib/components/qr-component/qr-popover.component.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAGE;EACE,iBAAA;EACA,kBAAA;AAAJ;;AAIA;EACE,uBAAA;AADF;AAEE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;AAAJ;AAEI;EACE,kBAAA;AAAN;;AAKA;EACE,gBAAA;EACA,eAAA;EACA,4BAAA;EACA,wBAAA;EACA,kBAAA;EACA,mBAAA;AAFF;;AAKA;EACE,gBAAA;EACA,eAAA;EACA,4BAAA;EACA,wBAAA;AAFF;;AAKA;EACE,qBAAA;AAFF;;AAKA;EACE,gBAAA;EACA,eAAA;EACA,4BAAA;EACA,wBAAA;AAFF;;AAKA;EACE,iCAAA;AAFF;;AAKA;EACE,iBAAA;AAFF;;AAKA;EACE,kBAAA;AAFF;;AAKA;EACE,sBAAA;AAFF","sourcesContent":["ion-content {\n  --background: white;\n}\n\n.qr-toolbar {\n  text-align: right;\n}\n\n#downladableQr {\n  div {\n    margin-left: 35px;\n    margin-right: 35px;\n  }\n}\n\n#options-qr {\n  justify-content: center;\n  ion-col {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: 500;\n    font-size: 14px;\n    margin-bottom: 10px;\n\n    ion-icon {\n      padding-right: 8px;\n    }\n  }\n}\n\n#title-modal {\n  font-weight: 700;\n  font-size: 17px;\n  color: var(--ion-text-color);\n  margin: 0px 0px 16px 0px;\n  padding-left: 16px;\n  padding-right: 16px;\n}\n\n#subtitle-modal {\n  font-weight: 400;\n  font-size: 17px;\n  color: var(--ion-text-color);\n  margin: 0px 0px 16px 0px;\n}\n\n.break-line {\n  white-space: pre-wrap;\n}\n\n#scan {\n  font-weight: 500;\n  font-size: 14px;\n  color: var(--ion-text-color);\n  margin: 7px 0px 7px 42px;\n}\n\n#goToSite {\n  color: var(--ion-color-secondary);\n}\n\n.row-actions{\n  padding: 0px 55px;\n}\n\n.btn-clear{\n  --box-shadow: none;\n}\n\n.btn-no-margin{\n  margin: 0px !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
